import "../common/common.js";
import { emailExists } from "../common/form-functions.js";

let isValid = true;
window.addEventListener('DOMContentLoaded',()=>{
    /*************************************/
    /*　　　　　入力中のバリデート　　　　　 */
    /*************************************/
    // ふりがなバリデーション
    let huriganaField = document.getElementById('hurigana');
    huriganaField.addEventListener('input', function() {
        let inputValue = huriganaField.value;
        // 許可する文字: ひらがな・英字
        const allowedRegex = /^[\u3040-\u309F\u30A0-\u30FFa-zA-Z\s]*$/;
            
        // 許可されない文字が含まれているか判定
        if (!allowedRegex.test(inputValue)) {
            document.getElementById('hurigana-caution').innerHTML = '<small>&#x26a0;ひらがな・英字以外は入力できません。</small>';
            isValid = false;
        } else {
            document.getElementById('hurigana-caution').innerHTML = '';
            isValid = true;
        }
    });
    // メールアドレスバリデーション
    let emailField = document.getElementById('email');
    emailField.addEventListener('input', function() {
        let inputValue = emailField.value;
        
        // メールアドレスのバリデーション用正規表現
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // 入力が不正な形式の場合
        if (!emailRegex.test(inputValue)) {
            document.getElementById('email-caution').innerHTML = '<small>&#x26a0;正しいメールアドレスを入力してください。</small>';
            isValid = false;
        } else {
            // 問題がなければ警告をクリア
            document.getElementById('email-caution').innerHTML = '';
            isValid = true;
        }
    });
    // 郵便番号から住所検索
    let postalCodeInput = document.getElementById('postal-code');
    const todouhuken = document.getElementById('todouhuken');
    const options = todouhuken.getElementsByTagName('option');
    postalCodeInput.addEventListener("input",()=>{
        let postalValue = postalCodeInput.value;
        if (postalValue) {
            fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${postalValue}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 200 && data.results) {
                    var result = data.results[0];
                    for (let i = 0; i < options.length; i++) {
                        if (options[i].textContent === result.address1) {
                            options[i].selected = true;
                            break;
                        }
                    }
                    document.getElementById('city').value = result.address2;
                    document.getElementById('street').value = result.address3;
                    const todouhukenCaution = document.getElementById('todouhuken-caution');
                    if (todouhukenCaution && todouhukenCaution.firstChild) {
                        todouhukenCaution.removeChild(todouhukenCaution.firstChild);
                    }
                    const cityCaution = document.getElementById('city-caution');
                    if (cityCaution && cityCaution.firstChild) {
                        cityCaution.removeChild(cityCaution.firstChild);
                    }
                    const streetCaution = document.getElementById('street-caution');
                    if (streetCaution && streetCaution.firstChild) {
                        streetCaution.removeChild(streetCaution.firstChild);
                    }
                }
            })
            .catch(error => {
                console.error('Error:', error);
                alert('エラーが発生しました');
            });
        }
    })
    //パスワードバリデーション
    let passwordField = document.getElementById('password');
    passwordField.addEventListener('input', function () {
        let inputValue = passwordField.value;
        // パスワードのバリデーション: 英数字9文字以上
        const passwordRegex = /^[a-zA-Z0-9]{9,}$/;
        // 入力が不正な場合
        if (!passwordRegex.test(inputValue)) {
            document.getElementById('password-caution').innerHTML = '<small>&#x26a0;パスワードは英数字9文字以上で入力してください。</small>';
            isValid = false;
        } else {
            document.getElementById('password-caution').innerHTML = '';
            isValid = true;
        }
    });
})

document.getElementById('registration-form').addEventListener('submit',async function(event) {
    event.preventDefault();

    // 必須項目の入力欄をチェック（.requireクラスがついているもの）
    document.querySelectorAll('.input-wrap.require').forEach(function(inputWrap) {
        const input = inputWrap.querySelector('input, select');
        let cautionElement = document.getElementById(input.id + '-caution'); 

        // 入力値が空白の場合
        if (!input.value.trim()) {
            cautionElement.innerHTML = '<small class="require-allert">&#x26a0;この項目は必須です。</small>';
            isValid = false;
        } else {
            cautionElement.innerHTML = '';
            isValid = true;
        }

        // 入力があった場合、警告を消す
        input.addEventListener('input', function() {
            if (input.value.trim()) {
                Array.from(cautionElement.children).forEach(child => {
                    if(child.className == 'require-allert'){
                        child.remove();
                    }
                });
            }
        });
    });

    
    let inputValue = document.getElementById('password').value;
    // パスワードのバリデーション: 英数字9文字以上
    const passwordRegex = /^[a-zA-Z0-9]{9,}$/;
    // 入力が不正な場合
    if (!passwordRegex.test(inputValue)) {
        document.getElementById('password-caution').innerHTML = '<small>&#x26a0;パスワードは英数字9文字以上で入力してください。</small>';
        isValid = false;
    } else {
        document.getElementById('password-caution').innerHTML = '';
        isValid = true;
    }

    // バリデーション失敗なら送信中止
    if (!isValid) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return false;
    }

    // メールアドレス重複チェック
    const email = document.getElementById('email').value;
    const exists = await emailExists(email);
    if (!exists) {
        alert('このメールアドレスは登録済みです。');
        return false;
    }

    // 入力に問題があればページを一番上にスクロール
    if (!isValid) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const formData = new FormData(this);
    const formObject = {};

    // 生年月日を結合して保存
    const year = formData.get('year') || '';
    const month = formData.get('mon') || '';
    const day = formData.get('day') || '';
    if (year && month && day) {
        const birthday = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        formObject['生年月日'] = birthday;
    }

    // フォームデータを日本語のキーで保存（生年月日以外）
    formData.forEach((value, key) => {
        if (key !== 'year' && key !== 'mon' && key !== 'day') {
            let label = document.querySelector(`label[for="${key}"]`)?.innerText;
            if (label) {
                formObject[label] = value;
            }
        }
    });

    // データをlocalStorageに保存
    localStorage.setItem('formData', JSON.stringify(formObject));

    // 確認画面に遷移
    if(isValid){
        window.location.href = 'confirm.html';
    }
});